import { render, staticRenderFns } from "./riskAnalysis.vue?vue&type=template&id=c20ff14e&scoped=true&"
import script from "./riskAnalysis.vue?vue&type=script&lang=js&"
export * from "./riskAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./riskAnalysis.vue?vue&type=style&index=0&id=c20ff14e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ff14e",
  null
  
)

export default component.exports